import * as advantage from './style.module.scss';
import * as React from "react";
export const advantageData = [
  {
    description:
      <><span className={advantage.advantage__bigText}>34</span> урока</>
  },
  {
    description:
      "Доступ на 1 год"
  },
  {
    description:
      "Поддержка кураторов и преподавателей"
  },
  {
    description:
      "Чат с учениками"
  },
  {
    description:
      <>Более <span className={advantage.advantage__bigText}>300</span> практических заданий</>
  }
];
